// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1kQnU","large":"styles_large__11w8G"};